import { render, staticRenderFns } from "./SituacaoSeguro.vue?vue&type=template&id=1cb0197b"
import script from "./SituacaoSeguro.vue?vue&type=script&lang=js"
export * from "./SituacaoSeguro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports